import React from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '@/components/ui/card';
import { Users, UserCheck, UserPlus, Clock, TrendingUp } from 'lucide-react';

/**
 * KPI Summary Cards Component
 * 
 * Displays key performance indicators at the top of admin dashboard
 */
const KPISummaryCards = ({ kpis, loading = false }) => {
  if (loading || !kpis) {
    return (
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
        {[1, 2, 3, 4].map(i => (
          <Card key={i} className="animate-pulse">
            <CardHeader className="pb-2">
              <div className="h-4 bg-gray-200 rounded w-24"></div>
            </CardHeader>
            <CardContent>
              <div className="h-8 bg-gray-200 rounded w-16"></div>
            </CardContent>
          </Card>
        ))}
      </div>
    );
  }
  
  const cards = [
    {
      title: 'Total Tutors',
      value: kpis.tutors.total,
      subtitle: `${kpis.tutors.recent_7_days} new in last 7 days`,
      icon: Users,
      color: 'text-blue-600'
    },
    {
      title: 'Pending Reviews',
      value: kpis.tutors.pending_review,
      subtitle: 'Awaiting review',
      icon: Clock,
      color: 'text-yellow-600'
    },
    {
      title: 'New Student Leads',
      value: kpis.students.new_leads,
      subtitle: `${kpis.students.recent_7_days} new in last 7 days`,
      icon: UserPlus,
      color: 'text-blue-600'
    },
    {
      title: 'Active Students',
      value: kpis.students.active,
      subtitle: `${kpis.students.assigned} assigned to tutors`,
      icon: UserCheck,
      color: 'text-green-600'
    }
  ];
  
  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4">
      {cards.map((card, index) => {
        const Icon = card.icon;
        return (
          <Card key={index}>
            <CardHeader className="pb-2">
              <CardTitle className="text-sm font-medium text-gray-600">
                {card.title}
              </CardTitle>
            </CardHeader>
            <CardContent>
              <div className="flex items-center justify-between">
                <div className={`text-3xl font-bold ${card.color}`}>
                  {card.value}
                </div>
                <Icon className={`h-8 w-8 ${card.color}`} />
              </div>
              <p className="text-xs text-gray-500 mt-2">
                {card.subtitle}
              </p>
            </CardContent>
          </Card>
        );
      })}
    </div>
  );
};

export default KPISummaryCards;
